import { useNavigate } from "react-router-dom";
import useEvent from "react-use-event-hook";

import { LandingRoutePaths, LandingStepEnum } from "../enums";
import { useLandingActions } from "./use-landings-actions";

export const useLandingsNavigation = () => {
  const { goToStep } = useLandingActions();
  const navigate = useNavigate();

  const navigateHome = useEvent((): void => {
    navigate(LandingRoutePaths.HOME);
  });

  const navigateLogin = useEvent((): void => {
    goToStep(LandingStepEnum.LoginStep);
  });

  const navigatePageNotFound = useEvent((): void => {
    navigate(LandingRoutePaths.PAGE_NOT_FOUND);
  });

  return {
    navigatePageNotFound,
    navigateLogin,
    navigateHome,
  };
};
